import { Button } from 'antd';
import React, { FC } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import ScrollTop from 'components/ScrollTop';
import complete from 'static/images/icons/complete.png';

import './style.scss';

const Success: FC<{ isIRA?: boolean }> = ({ isIRA }) => {
    const location = useLocation();
    // 此处是用来校验是否用户真的是提交成功进入的页面、而不是直接改变路由进入的
    const { successKey } = (location.state as { successKey: number } | null) || {};

    if (!successKey) {
        return <Navigate to="/profile/withdraw" replace />;
    }

    return (
        <div className="withdraw-wire-complete-root">
            <ScrollTop />
            <h3 className="main-title">{isIRA ? __('Request received!') : __('Withdraw by wire')}</h3>
            <div className="success-info">
                <img className="success-img" src={complete} alt={__('success')} />
                <p className="success-text">
                    {isIRA
                        ? __(
                              "Your distribution request has been submitted successfully. We'll inform you once the withdrawal has been processed."
                          )
                        : __(
                              'We have received your wire withdrawal request! Please continue to monitor your email for updates.'
                          )}
                </p>
            </div>
            <Link to="..">
                <Button type="primary" className="btn-important success-btn">
                    {__('Done')}
                </Button>
            </Link>
        </div>
    );
};

export default Success;
